__turbopack_context__.v({
  "button": "SignUpTag-module-scss-module___inY_a__button",
  "fade-in": "SignUpTag-module-scss-module___inY_a__fade-in",
  "icon": "SignUpTag-module-scss-module___inY_a__icon",
  "label": "SignUpTag-module-scss-module___inY_a__label",
  "reveal": "SignUpTag-module-scss-module___inY_a__reveal",
  "root": "SignUpTag-module-scss-module___inY_a__root",
});
